document.addEventListener("DOMContentLoaded", function () {
	const slideshow = document.querySelector(".ads-slideshow");
	if (!slideshow) {
		return;
	}
	const track = slideshow.querySelector(".content_box-top__description");
	if (!track) {
		console.warning("Track not found");
		return;
	}
	const images = Array.from(track.querySelectorAll("img"));

	if ( images.length === 0) {
		console.warning("No images found in the track");
		return;
	}

	let currentIndex = 0;
	let touchStartX = 0;
	let touchEndX = 0;
	let isPaused = false; // State to track whether autoplay is paused
	let slideInterval; // Store the interval for autoplay
	let progressInterval; // Store the interval for updating progress bar
	let progressValue = 0; // Progress value for each image

	// Apply styles
	track.style.display = "flex";
	track.style.transition = "transform 0.5s ease-in-out";
	track.style.width = "100%";
	slideshow.style.overflow = "hidden";

	images.forEach(img => {
	  img.style.flex = "0 0 100%";
	  img.style.width = "100%";
	  img.style.height = "auto";
	  img.style.objectFit = "contain";
	});

	// Create pause/play button

	// Pause Button
	const pauseButton = document.createElement("button");
	pauseButton.classList.add("slideshow-pause-button");

	const svgPauseIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<rect x="4" y="4" width="4" height="16" />
		<rect x="10" y="4" width="4" height="16" />
	</svg>
	`;

	const svgPlayIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<polygon points="5,3 19,12 5,21" />
	</svg>
	`;

	pauseButton.innerHTML = svgPauseIcon; // Start with pause icon

	// Add click listener to toggle between pause and play
	pauseButton.addEventListener("click", () => {
	isPaused = !isPaused; // Toggle the isPaused state

	if (isPaused) {
		stopAutoplay(); // Function to stop the autoplay
		pauseButton.innerHTML = svgPlayIcon; // Change icon to play
	} else {
		startAutoplay(); // Function to start the autoplay
		pauseButton.innerHTML = svgPauseIcon; // Change icon to pause
	}
	});

	// Add the play/pause button and dots to the controls container
	const controlsContainer = document.createElement("div");
	controlsContainer.classList.add("slideshow-controls");

	controlsContainer.appendChild(pauseButton);

	// Create dots
	const dotsContainer = document.createElement("div");
	dotsContainer.classList.add("slideshow-dots");

	images.forEach((_, index) => {
	  const dot = document.createElement("div");
	  dot.classList.add("dot");
	  if (index === 0) dot.classList.add("active");
	  dot.addEventListener("click", () => {
		goToSlide(index);
		resetAutoplay();
	  });
	  dotsContainer.appendChild(dot);
	});
	controlsContainer.appendChild(dotsContainer);


	// Add progress bar
	const progressBarContainer = document.createElement("div");
	progressBarContainer.classList.add("slideshow-progress-bar");

	const progress = document.createElement("div");
	progress.classList.add("progress");

	progressBarContainer.appendChild(progress);

	slideshow.appendChild(progressBarContainer);

	// Append controls
	slideshow.appendChild(controlsContainer);

	function goToSlide(index) {
	  currentIndex = (index + images.length) % images.length;
	  track.style.transform = `translateX(-${100 * currentIndex}%)`;

	  // Update dots
	  dotsContainer.querySelectorAll(".dot").forEach((dot, i) => {
		dot.classList.toggle("active", i === currentIndex);
	  });

	  // Update active image
	  images.forEach((img, i) => {
		img.classList.toggle("active", i === currentIndex);
	  });
	}

	function nextSlide() {
		goToSlide(currentIndex + 1);
		progressValue = 0;
		progress.style.width = '0%';
	}

	function startAutoplay() {
	  if (!isPaused) {
		autoPlayInterval = setInterval(nextSlide, 5000);
	  }
	}


	// Function to start autoplay
	function startAutoplay() {
		// Reset progress bar
		progressValue = 0;
		progress.style.width = '0%';

		// Slide change interval (for example, change every 5 seconds)
		slideInterval = setInterval(() => {
			nextSlide();
		}, 5000); // Change slide every 5 seconds

		// Progress bar update interval (update every 50ms)
		progressInterval = setInterval(() => {
		progressValue += 100 / 5000 * 50; // Calculate progress based on the 5-second interval
		if (progressValue >= 100) {
			progressValue = 100;
			clearInterval(progressInterval); // Stop updating when progress is 100%
		}
		progress.style.width = `${progressValue}%`;
		}, 50); // Update progress every 50ms
	}


	// Function to stop autoplay
	function stopAutoplay() {
		clearInterval(slideInterval);
		clearInterval(progressInterval);
		console.log('Autoplay stopped');
	}


	function resetAutoplay() {
	  stopAutoplay();
	  startAutoplay();
	}

	// Pause on hover
	slideshow.addEventListener("mouseenter", stopAutoplay);
	slideshow.addEventListener("mouseleave", () => {
	  if (!isPaused) startAutoplay();
	});

	// Touch swipe
	slideshow.addEventListener("touchstart", e => {
	  touchStartX = e.changedTouches[0].screenX;
	});

	slideshow.addEventListener("touchend", e => {
	  touchEndX = e.changedTouches[0].screenX;
	  handleSwipe();
	});

	function handleSwipe() {
	  const deltaX = touchEndX - touchStartX;
	  if (Math.abs(deltaX) > 50) {
		if (deltaX < 0) {
		  goToSlide(currentIndex + 1);
		} else {
		  goToSlide(currentIndex - 1);
		}
		resetAutoplay();
	  }
	}

	// Init
	goToSlide(0);
	startAutoplay();
  });
